import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import RecordHistory from 'components/RecordHistory/RecordHistory'
import { Spinner } from 'components/Loaders/Loaders'

const ApostilleHistoryPanel = ({ loadingHistory }) => {
  const { expandableHistory } = useSelector((state) => state.record, shallowEqual)
  if (loadingHistory)
    return (
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '60px' }}>
        <Spinner size="large" themeColor="dark-neutral" />
      </div>
    )
  return (
    <RecordHistory
      history={{
        ...expandableHistory,
      }}
      requiredVoidRight="ApostilleVoid"
    />
  )
}

export default ApostilleHistoryPanel
